import application from 'application/application';

import template from './login.template.html';

import controller from './login.controller';

application.config(['$stateProvider', $stateProvider => {
	$stateProvider.state('root.login', {
		views: {
			'root': {
				templateUrl: template,
				controller
			}
		},
		resolve: {
			ticket: function() {
				let url = window.location.href;

				let token;

				if ((url.indexOf('access_token?=') > -1)) {

					token = url.slice(url.indexOf('access_token?='),url.length).replace('access_token?=','');

					return token;
				} else {
					token = null;

					return token;
				}
			}
		},
		data: {
			documentTitle: 'Login'
		},
		params: {
			authentication: false
		}
	});
}]);
